import baseService from '../utils/axios';
import {UUID} from "../interfaces/general";

export const importShopifyProducts = async () => baseService.post(
  '/shopify/import_products'
);

export const getShopifyProducts = async (page: number) => baseService.get(
  `/shopify/products?page=${page}`
);

export const getShopifyAuthUrl = async (params: string) => baseService.get(
  `/service_oauth/guest_auth_url/shopify?${params}`
);

export const createShopifySubscription = async (planName: string, returnSlug?: string) => baseService.post(
  '/shopify/create_subscription',
  { 
    plan_name: planName,
    return_slug: returnSlug || null
   }
);

export const cancelShopifySubscription = async () => baseService.post(
  '/shopify/cancel_subscription'
);

export const verifyShopifyHmac = async (hmac: string, message: string) => baseService.post(
  '/service_oauth/auth_verify_hmac',
  { hmac, message }
);

export const getShopifySubscriptionData = async () => baseService.get(
  '/shopify/subscription'
);

export const removeShopifyAuth = async () => baseService.post(
  '/shopify/remove_auth'
);

export const updateShopifyProductStatus = async (productId: number, status: string) => baseService.post(
  '/shopify/update_product_status',
  {
    product_id: productId,
    status
  }
);

export const uploadShopifyProductQAs = async (productId: number, qaText: string) => baseService.post(
  '/shopify/add_qa_to_product',
  {
    product_id: productId,
    raw_qa_text: qaText
  }
);

export const uploadShopifyProductsQAs = async (productIds: number[], qaText: string) => baseService.post(
  '/shopify/add_qas_to_products_list',
  {
    product_ids: productIds,
    raw_qa_text: qaText
  }
);


export const deleteShopifyProductQA = async (productId: number, qaId: string) => baseService.post(
  '/shopify/delete_product_qa',
  {
    product_id: productId,
    qa_id: qaId
  }
);


export const searchShopifyProducts = async (page: number, searchTerm: string) => baseService.post(
  '/shopify/search_products',
  {
    page,
    search_term: searchTerm
  }
);


export const getProductsByIds = async (productIds: number[]) => baseService.post(
  '/shopify/get_products_list',
  {
    product_ids: productIds
  }
);

export const loadAllProductsGraphQL = async () => baseService.get('/shopify/load_all_products_graphql');

export const loadOneProductGraphQLTest = async () => baseService.get(`/shopify/get_one_product_test`);

export const loadOneShopifyProduct = async (productId: number) => baseService.post(
  '/shopify/load_one_product',
  {
    product_id: productId
  }
);

